import { ProjectCardFieldsFragment, ProjectFieldsFragment } from "@govlaunch/project";
import gql from "graphql-tag";

export default gql`
  query GetGovernment($slug: String!) {
    government(slug: $slug) {
      _id
      slug
      logo
      name
      enableSharing
      site
      city {
        _id
        name
        state
        governmentType
      }
      sharing {
        team
        productStack
        projects
        stories
        resources
        awards
      }
      products {
        _id
        name
        slug
        logo
        isDisruptor
        company {
          _id
          slug
          name
        }
      }
      awards {
        _id
        name
      }
      stories(audience: PUBLIC) {
        items {
          _id
          title
          slug
          verticalCover
          introduction
          viewerCanRead
          viewerIsAuthor
          viewerDidBookmark
          updatedAt
          status
          government {
            _id
            slug
            name
            logo
          }
        }
      }
      members {
        _id
        slug
        fullName
        jobTitle
        avatar
        isInnovator
      }
      resources {
        ... on LinkResource {
          type
          title
          url
        }
        ... on DownloadResource {
          type
          filename
          title
          url
        }
      }
      projects(audience: PUBLIC) {
        items {
          ...ProjectFields
          ...ProjectCardFields
          icon
          itemsCount {
            products
            newsworthy
            attachments
            locations
            links
            vendors
          }
        }
      }
    }
  }

  ${ProjectFieldsFragment}
  ${ProjectCardFieldsFragment}
`;
